// import { Card } from "react-bootstrap";
// import "../assets/css/login.css";
// import Logo from "../assets/img/logo.png";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Modal, Button, Form } from "react-bootstrap";
// import { useState } from "react";
// import { useDispatch } from "react-redux";
// import { EmployeeLogin } from "../store/actions/auth";
// import { redirect, useNavigate, Link } from "react-router-dom";
// // import {
// //   requestPasswordOtp,
// //   verifyPasswordOtp,
// //   resetPassword,
// // } from "../services/auth.service";
// import requestPasswordOtp from "../services/auth.service";
// import verifyPasswordOtp from "../services/auth.service";
// import resetPassword from "../services/auth.service";
// const HRMSLogin = () => {
//   const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
//   const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
//   const [emailForReset, setEmailForReset] = useState("");
//   const [otpSentUserId, setOtpSentUserId] = useState(null);
//   const [resetPasswordToken, setResetPasswordToken] = useState("");
//   const [forgotPasswordError, setForgotPasswordError] = useState("");
//   const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState("");
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const formik = useFormik({
//     initialValues: {
//       username: "",
//       password: "",
//       role: "EMPLOYEE",
//     },
//     validationSchema: Yup.object({
//       username: Yup.string().required("Required"),
//       password: Yup.string()
//         .max(50, "Must be 50 characters or less")
//         .min(5, "Must be 5 characters or more")
//         .required("Required"),
//       role: Yup.string().required("Required"),
//     }),
//     //   onSubmit: ({ username, password, role }) => {
//     //     dispatch(EmployeeLogin(username, password, role)).then((res) => {
//     //       if (res) {
//     //         if (role === "HR") navigate("/hrms/dashboard");
//     //         else if (role === "MANAGER") navigate("/manager-dashboard");
//     //         else if (role === "EMPLOYEE") navigate("/employee-dashboard");
//     //       }
//     //     });
//     //   },
//     // });
//     onSubmit: async ({ username, password, role }) => {
//       const res = await dispatch(EmployeeLogin(username, password, role));

//       if (res) {
//         // Redirect based on role
//         if (role === "HR") {
//           navigate("/hrms/dashboard");
//         }
//         // else if (role === "Manager" || role === "EMPLOYEE") {
//         //   navigate("/hrms/home");
//         else if (role === "MANAGER") {
//           navigate("/hrms/manager-dashboard");
//         } else if (role === "EMPLOYEE") {
//           navigate("/hrms/employee-dashboard");
//         }
//       }
//     },
//   });
//   const forgotPasswordFormik = useFormik({
//     initialValues: {
//       email: "",
//       otp: "",
//       newPassword: "",
//       confirmNewPassword: "",
//     },
//     validationSchema: Yup.object().shape({
//       email: Yup.string().email("Invalid email").required("Email is required"),
//       otp: Yup.string().when("forgotPasswordStep", {
//         is: 2,
//         then: Yup.string()
//           .required("OTP is required")
//           .length(6, "OTP must be 6 digits"),
//       }),
//       newPassword: Yup.string().when("forgotPasswordStep", {
//         is: 3,
//         then: Yup.string()
//           .required("New Password is required")
//           .min(5, "Password must be at least 5 characters"),
//       }),
//       confirmNewPassword: Yup.string().when("forgotPasswordStep", {
//         is: 3,
//         then: Yup.string()
//           .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
//           .required("Confirm Password is required"),
//       }),
//     }),
//     onSubmit: async (values) => {
//       setForgotPasswordError("");
//       setForgotPasswordSuccess("");
//       try {
//         if (forgotPasswordStep === 1) {
//           // Request OTP
//           const response = await requestPasswordOtp.requestPasswordOtp(
//             values.email
//           );
//           if (response.status === 1) {
//             setEmailForReset(values.email);
//             setOtpSentUserId(response.userId);
//             setForgotPasswordStep(2);
//             setForgotPasswordSuccess("OTP sent to your email.");
//             forgotPasswordFormik.setFieldValue("otp", "");
//           } else {
//             setForgotPasswordError(response.message || "Failed to send OTP.");
//           }
//         } else if (forgotPasswordStep === 2) {
//           // Verify OTP
//           console.log(
//             "Verifying OTP for userId:",
//             otpSentUserId,
//             "with OTP:",
//             values.otp
//           );
//           const trimmedOtp = String(values.otp).trim();
//           const response = await verifyPasswordOtp.verifyPasswordOtp(
//             Number(otpSentUserId),
//             trimmedOtp
//           );
//           // const response = await verifyPasswordOtp.verifyPasswordOtp(
//           //   otpSentUserId,
//           //   values.otp
//           // );
//           if (response.status === 1) {
//             setResetPasswordToken(response.resetToken);
//             setForgotPasswordStep(3);
//             setForgotPasswordSuccess(
//               "OTP verified. Please set your new password."
//             );
//             forgotPasswordFormik.setFieldValue("newPassword", "");
//             forgotPasswordFormik.setFieldValue("confirmNewPassword", "");
//           } else {
//             setForgotPasswordError(response.message || "Failed to verify OTP.");
//           }
//         } else if (forgotPasswordStep === 3) {
//           // Reset Password
//           const response = await resetPassword.resetPassword(
//             resetPasswordToken,
//             values.newPassword
//           );
//           if (response.status === 1) {
//             setForgotPasswordSuccess(
//               "Password reset successfully! You can now log in with your new password."
//             );
//             setTimeout(() => {
//               handleCloseForgotPasswordModal();
//             }, 3000); // Close after 3 seconds
//           } else {
//             setForgotPasswordError(
//               response.message || "Failed to reset password."
//             );
//           }
//         }
//       } catch (error) {
//         const errorMessage = error.message || "An unexpected error occurred.";
//         setForgotPasswordError(errorMessage);
//         console.error("Forgot password flow error:", error);
//       }
//     },
//     enableReinitialize: true, // Important for validation schema to react to step changes
//   });

//   const handleShowForgotPasswordModal = () => {
//     setShowForgotPasswordModal(true);
//     setForgotPasswordStep(1);
//     setEmailForReset("");
//     setOtpSentUserId(null);
//     setResetPasswordToken("");
//     setForgotPasswordError("");
//     setForgotPasswordSuccess("");
//     forgotPasswordFormik.resetForm();
//   };

//   const handleCloseForgotPasswordModal = () => {
//     setShowForgotPasswordModal(false);
//     setForgotPasswordStep(1);
//     setEmailForReset("");
//     setOtpSentUserId(null);
//     setResetPasswordToken("");
//     setForgotPasswordError("");
//     setForgotPasswordSuccess("");
//     forgotPasswordFormik.resetForm();
//   };

//   return (
//     // <div className="d-flex justify-content-center align-items-center my-auto login_container">
//     //   <Card className="shadow p-4">
//     //     <Card.Body>
//     //       <div className="text-center">
//     //         <img src={Logo} alt="logo" className="logo" />
//     //       </div>
//     //       <form onSubmit={formik.handleSubmit}>
//     //         <div className="row mt-4">
//     //           <div className="col-2 d-none d-lg-block">
//     //             <label className="text-muted" htmlFor="username">
//     //               Username*
//     //             </label>
//     //           </div>
//     //           <div className="col-12 col-lg-10">
//     //             <input
//     //               type="text"
//     //               className="form-control icueLoginEmail "
//     //               name="username"
//     //               onChange={formik.handleChange}
//     //               onBlur={formik.handleBlur}
//     //               id="icueLoginEmail"
//     //               placeholder="Enter username"
//     //               value={formik.values.username}
//     //             />
//     //             {formik.touched.username && formik.errors.username ? (
//     //               <div
//     //                 style={{
//     //                   color: "red",
//     //                   fontSize: "16px",
//     //                   fontFamily: "Calibri",
//     //                 }}
//     //               >
//     //                 {formik.errors.username}
//     //               </div>
//     //             ) : null}
//     //           </div>
//     //         </div>
//     //         <div className="row mt-3">
//     //           <div className="col-2 d-none d-lg-block">
//     //             <label className="text-muted" htmlFor="Password">
//     //               Password*
//     //             </label>
//     //           </div>
//     //           <div className="col-lg-10 col-12">
//     //             <input
//     //               type="password"
//     //               className="form-control icueLoginPwd border-end-0 text-capitalize"
//     //               name="password"
//     //               onChange={formik.handleChange}
//     //               onBlur={formik.handleBlur}
//     //               id="icueLoginPwd"
//     //               placeholder="enter password"
//     //               value={formik.values.password}
//     //             />
//     //             {formik.touched.password && formik.errors.password ? (
//     //               <div
//     //                 style={{
//     //                   color: "red",
//     //                   fontSize: "16px",
//     //                   fontFamily: "Calibri",
//     //                 }}
//     //               >
//     //                 {formik.errors.password}
//     //               </div>
//     //             ) : null}
//     //           </div>
//     //         </div>
//     //         <div className="row mt-3">
//     //           <div className="col-2 d-none d-lg-block">
//     //             <label className="text-muted" htmlFor="Role">
//     //               Role*
//     //             </label>
//     //           </div>
//     //           <div className="col-lg-10 col-12">
//     //             <select
//     //               className="form-select form-select-sm icueLoginRole text-muted text-capitalize"
//     //               aria-label="form-select-sm icueLoginRole"
//     //               name="role"
//     //               id="icueLoginRole"
//     //               value={formik.values.role}
//     //               onChange={formik.handleChange}
//     //               onBlur={formik.handleBlur}
//     //             >
//     //               <option value="HR">HR</option>
//     //               <option value="EMPLOYEE">EMPLOYEE</option>
//     //               <option value="MANAGER">MANAGER</option>
//     //             </select>
//     //             {formik.touched.role && formik.errors.role ? (
//     //               <div
//     //                 style={{
//     //                   color: "red",
//     //                   fontSize: "16px",
//     //                   fontFamily: "Calibri",
//     //                 }}
//     //               >
//     //                 {formik.errors.role}
//     //               </div>
//     //             ) : null}
//     //           </div>
//     //         </div>
//     //         <div className="row mt-3">
//     //           <div className="col-2 d-none d-lg-block">{""}</div>
//     //           <div className="col-lg-10 col-12">
//     //             <button
//     //               type="submit"
//     //               className="btn btn-primary "
//     //               style={{
//     //                 fontSize: "16px",
//     //                 fontFamily: "Calibri",
//     //                 width: "100%",
//     //               }}
//     //             >
//     //               Login
//     //             </button>
//     //             <div className="text-center mt-3">
//     //               <Link to="/hrms/forgot-password">Forgot Password?</Link>
//     //             </div>
//     //           </div>
//     //         </div>
//     //       </form>
//     //     </Card.Body>
//     //   </Card>
//     // </div>
//     <div className="d-flex justify-content-center align-items-center my-auto login_container">
//       <Card className="shadow p-4">
//         <Card.Body>
//           <div className="text-center">
//             <img src={Logo} alt="logo" className="logo" />
//           </div>
//           <form onSubmit={formik.handleSubmit}>
//             <div className="row mt-4">
//               <div className="col-2 d-none d-lg-block">
//                 <label className="text-muted" htmlFor="username">
//                   Username*
//                 </label>
//               </div>
//               <div className="col-12 col-lg-10">
//                 <input
//                   type="text"
//                   className="form-control icueLoginEmail"
//                   name="username"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   id="icueLoginEmail"
//                   placeholder="Enter username"
//                   value={formik.values.username}
//                 />
//                 {formik.touched.username && formik.errors.username ? (
//                   <div className="text-danger mt-1">
//                     {formik.errors.username}
//                   </div>
//                 ) : null}
//               </div>
//             </div>
//             <div className="row mt-3">
//               <div className="col-2 d-none d-lg-block">
//                 <label className="text-muted" htmlFor="Password">
//                   Password*
//                 </label>
//               </div>
//               <div className="col-lg-10 col-12">
//                 <input
//                   type="password"
//                   className="form-control icueLoginPwd border-end-0 text-capitalize"
//                   name="password"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   id="icueLoginPwd"
//                   placeholder="enter password"
//                   value={formik.values.password}
//                 />
//                 {formik.touched.password && formik.errors.password ? (
//                   <div className="text-danger mt-1">
//                     {formik.errors.password}
//                   </div>
//                 ) : null}
//               </div>
//             </div>
//             <div className="row mt-3">
//               <div className="col-2 d-none d-lg-block">
//                 <label className="text-muted" htmlFor="Role">
//                   Role*
//                 </label>
//               </div>
//               <div className="col-lg-10 col-12">
//                 <select
//                   className="form-select form-select-sm icueLoginRole text-muted text-capitalize"
//                   aria-label="form-select-sm icueLoginRole"
//                   name="role"
//                   id="icueLoginRole"
//                   value={formik.values.role}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 >
//                   <option value="HR">HR</option>
//                   <option value="EMPLOYEE">EMPLOYEE</option>
//                   <option value="MANAGER">MANAGER</option>
//                 </select>
//                 {formik.touched.role && formik.errors.role ? (
//                   <div className="text-danger mt-1">{formik.errors.role}</div>
//                 ) : null}
//               </div>
//             </div>
//             <div className="row mt-3">
//               <div className="col-2 d-none d-lg-block">{""}</div>
//               <div className="col-lg-10 col-12">
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   style={{ width: "100%" }}
//                 >
//                   Login
//                 </button>
//                 <div className="text-center mt-2">
//                   <Link
//                     to="#"
//                     className="text-decoration-none"
//                     onClick={handleShowForgotPasswordModal}
//                   >
//                     Forgot Password?
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </Card.Body>
//       </Card>

//       {/* Forgot Password Modal */}
//       <Modal
//         show={showForgotPasswordModal}
//         onHide={handleCloseForgotPasswordModal}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Forgot Password</Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={forgotPasswordFormik.handleSubmit}>
//           <Modal.Body>
//             {forgotPasswordError && (
//               <div className="alert alert-danger">{forgotPasswordError}</div>
//             )}
//             {forgotPasswordSuccess && (
//               <div className="alert alert-success">{forgotPasswordSuccess}</div>
//             )}

//             {forgotPasswordStep === 1 && (
//               <Form.Group className="mb-3" controlId="formBasicEmail">
//                 <Form.Label>Enter your email address</Form.Label>
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter email"
//                   name="email"
//                   value={forgotPasswordFormik.values.email}
//                   onChange={forgotPasswordFormik.handleChange}
//                   onBlur={forgotPasswordFormik.handleBlur}
//                   isInvalid={
//                     forgotPasswordFormik.touched.email &&
//                     !!forgotPasswordFormik.errors.email
//                   }
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {forgotPasswordFormik.errors.email}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             )}

//             {forgotPasswordStep === 2 && (
//               <Form.Group className="mb-3" controlId="formBasicOtp">
//                 <Form.Label>Enter the OTP sent to {emailForReset}</Form.Label>
//                 <Form.Control
//                   type="text"
//                   placeholder="Enter 6-digit OTP"
//                   name="otp"
//                   value={forgotPasswordFormik.values.otp}
//                   onChange={forgotPasswordFormik.handleChange}
//                   onBlur={forgotPasswordFormik.handleBlur}
//                   isInvalid={
//                     forgotPasswordFormik.touched.otp &&
//                     !!forgotPasswordFormik.errors.otp
//                   }
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {forgotPasswordFormik.errors.otp}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             )}

//             {forgotPasswordStep === 3 && (
//               <>
//                 <Form.Group className="mb-3" controlId="formBasicNewPassword">
//                   <Form.Label>New Password</Form.Label>
//                   <Form.Control
//                     type="password"
//                     placeholder="Enter new password"
//                     name="newPassword"
//                     value={forgotPasswordFormik.values.newPassword}
//                     onChange={forgotPasswordFormik.handleChange}
//                     onBlur={forgotPasswordFormik.handleBlur}
//                     isInvalid={
//                       forgotPasswordFormik.touched.newPassword &&
//                       !!forgotPasswordFormik.errors.newPassword
//                     }
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {forgotPasswordFormik.errors.newPassword}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//                 <Form.Group
//                   className="mb-3"
//                   controlId="formBasicConfirmNewPassword"
//                 >
//                   <Form.Label>Confirm New Password</Form.Label>
//                   <Form.Control
//                     type="password"
//                     placeholder="Confirm new password"
//                     name="confirmNewPassword"
//                     value={forgotPasswordFormik.values.confirmNewPassword}
//                     onChange={forgotPasswordFormik.handleChange}
//                     onBlur={forgotPasswordFormik.handleBlur}
//                     isInvalid={
//                       forgotPasswordFormik.touched.confirmNewPassword &&
//                       !!forgotPasswordFormik.errors.confirmNewPassword
//                     }
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {forgotPasswordFormik.errors.confirmNewPassword}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={handleCloseForgotPasswordModal}
//             >
//               Close
//             </Button>
//             <Button variant="primary" type="submit">
//               {forgotPasswordStep === 1 && "Send OTP"}
//               {forgotPasswordStep === 2 && "Verify OTP"}
//               {forgotPasswordStep === 3 && "Reset Password"}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default HRMSLogin;
import { Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { EmployeeLogin } from "../store/actions/auth";
import "../assets/css/login.css";
import requestPasswordOtp from "../services/auth.service";
import verifyPasswordOtp from "../services/auth.service";
import resetPassword from "../services/auth.service";

const HRMSLogin = () => {
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
  const [emailForReset, setEmailForReset] = useState("");
  const [otpSentUserId, setOtpSentUserId] = useState(null);
  const [resetPasswordToken, setResetPasswordToken] = useState("");
  const [forgotPasswordError, setForgotPasswordError] = useState("");
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      role: "EMPLOYEE",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Required"),
      password: Yup.string()
        .max(50, "Must be 50 characters or less")
        .min(5, "Must be 5 characters or more")
        .required("Required"),
      role: Yup.string().required("Required"),
    }),
    onSubmit: async ({ username, password, role }) => {
      const res = await dispatch(EmployeeLogin(username, password, role));

      if (res) {
        // Redirect based on role to CORRECT dashboards
        // if (role === "HR") {
        //   navigate("/hrms/dashboard");
        // } else if (role === "MANAGER") {
        //   navigate("/hrms/manager-dashboard"); // Manager Team Dashboard
        // } else if (role === "EMPLOYEE") {
        //   navigate("/hrms/employee-dashboard"); // Employee Dashboard
        // }
        if (res.role === "HR") {
          navigate("/hrms/dashboard");
        } else if (res.role === "MANAGER") {
          navigate("/hrms/manager-dashboard");
        } else if (res.role === "EMPLOYEE") {
          navigate("/hrms/employee-dashboard");
        }
      }
    },
  });

  const forgotPasswordFormik = useFormik({
    initialValues: {
      email: "",
      otp: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email("Invalid email").required("Email is required"),
      otp: Yup.string().when("forgotPasswordStep", {
        is: 2,
        then: Yup.string()
          .required("OTP is required")
          .length(6, "OTP must be 6 digits"),
      }),
      newPassword: Yup.string().when("forgotPasswordStep", {
        is: 3,
        then: Yup.string()
          .required("New Password is required")
          .min(5, "Password must be at least 5 characters"),
      }),
      confirmNewPassword: Yup.string().when("forgotPasswordStep", {
        is: 3,
        then: Yup.string()
          .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
          .required("Confirm Password is required"),
      }),
    }),
    onSubmit: async (values) => {
      setForgotPasswordError("");
      setForgotPasswordSuccess("");
      try {
        if (forgotPasswordStep === 1) {
          const response = await requestPasswordOtp.requestPasswordOtp(
            values.email
          );
          if (response.status === 1) {
            setEmailForReset(values.email);
            setOtpSentUserId(response.userId);
            setForgotPasswordStep(2);
            setForgotPasswordSuccess("OTP sent to your email.");
            forgotPasswordFormik.setFieldValue("otp", "");
          } else {
            setForgotPasswordError(response.message || "Failed to send OTP.");
          }
        } else if (forgotPasswordStep === 2) {
          const trimmedOtp = String(values.otp).trim();
          const response = await verifyPasswordOtp.verifyPasswordOtp(
            Number(otpSentUserId),
            trimmedOtp
          );
          if (response.status === 1) {
            setResetPasswordToken(response.resetToken);
            setForgotPasswordStep(3);
            setForgotPasswordSuccess(
              "OTP verified. Please set your new password."
            );
            forgotPasswordFormik.setFieldValue("newPassword", "");
            forgotPasswordFormik.setFieldValue("confirmNewPassword", "");
          } else {
            setForgotPasswordError(response.message || "Failed to verify OTP.");
          }
        } else if (forgotPasswordStep === 3) {
          const response = await resetPassword.resetPassword(
            resetPasswordToken,
            values.newPassword
          );
          if (response.status === 1) {
            setForgotPasswordSuccess(
              "Password reset successfully! You can now log in with your new password."
            );
            setTimeout(() => {
              handleCloseForgotPasswordModal();
            }, 3000);
          } else {
            setForgotPasswordError(
              response.message || "Failed to reset password."
            );
          }
        }
      } catch (error) {
        const errorMessage = error.message || "An unexpected error occurred.";
        setForgotPasswordError(errorMessage);
        console.error("Forgot password flow error:", error);
      }
    },
    enableReinitialize: true,
  });

  const handleShowForgotPasswordModal = () => {
    setShowForgotPasswordModal(true);
    setForgotPasswordStep(1);
    setEmailForReset("");
    setOtpSentUserId(null);
    setResetPasswordToken("");
    setForgotPasswordError("");
    setForgotPasswordSuccess("");
    forgotPasswordFormik.resetForm();
  };

  const handleCloseForgotPasswordModal = () => {
    setShowForgotPasswordModal(false);
    setForgotPasswordStep(1);
    setEmailForReset("");
    setOtpSentUserId(null);
    setResetPasswordToken("");
    setForgotPasswordError("");
    setForgotPasswordSuccess("");
    forgotPasswordFormik.resetForm();
  }; 

  return (
    <div className="d-flex justify-content-center align-items-center my-auto login_container">
      <Card className="shadow p-4">
        <Card.Body>
          <div className="text-center">
            <img src={Logo} alt="logo" className="logo" />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="row mt-4">
              <div className="col-2 d-none d-lg-block">
                <label className="text-muted" htmlFor="username">
                  Username*
                </label>
              </div>
              <div className="col-12 col-lg-10">
                <input
                  type="text"
                  className="form-control icueLoginEmail"
                  name="username"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  id="icueLoginEmail"
                  placeholder="Enter username"
                  value={formik.values.username}
                />
                {formik.touched.username && formik.errors.username ? (
                  <div className="text-danger mt-1">
                    {formik.errors.username}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-2 d-none d-lg-block">
                <label className="text-muted" htmlFor="Password">
                  Password*
                </label>
              </div>
              <div className="col-lg-10 col-12">
                <input
                  type="password"
                  className="form-control icueLoginPwd border-end-0 text-capitalize"
                  name="password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  id="icueLoginPwd"
                  placeholder="enter password"
                  value={formik.values.password}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-danger mt-1">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-2 d-none d-lg-block">
                <label className="text-muted" htmlFor="Role">
                  Role*
                </label>
              </div>
              <div className="col-lg-10 col-12">
                <select
                  className="form-select form-select-sm icueLoginRole text-muted text-capitalize"
                  aria-label="form-select-sm icueLoginRole"
                  name="role"
                  id="icueLoginRole"
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="HR">HR</option>
                  <option value="EMPLOYEE">EMPLOYEE</option>
                  <option value="MANAGER">MANAGER</option>
                </select>
                {formik.touched.role && formik.errors.role ? (
                  <div className="text-danger mt-1">{formik.errors.role}</div>
                ) : null}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-2 d-none d-lg-block">{""}</div>
              <div className="col-lg-10 col-12">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: "100%" }}
                >
                  Login
                </button>
                <div className="text-center mt-2">
                  <Link
                    to="#"
                    className="text-decoration-none"
                    onClick={handleShowForgotPasswordModal}
                  >
                    Forgot Password?
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </Card.Body>
      </Card>

      {/* Forgot Password Modal */}
      <Modal
        show={showForgotPasswordModal}
        onHide={handleCloseForgotPasswordModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Form onSubmit={forgotPasswordFormik.handleSubmit}>
          <Modal.Body>
            {forgotPasswordError && (
              <div className="alert alert-danger">{forgotPasswordError}</div>
            )}
            {forgotPasswordSuccess && (
              <div className="alert alert-success">{forgotPasswordSuccess}</div>
            )}

            {forgotPasswordStep === 1 && (
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Enter your email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={forgotPasswordFormik.values.email}
                  onChange={forgotPasswordFormik.handleChange}
                  onBlur={forgotPasswordFormik.handleBlur}
                  isInvalid={
                    forgotPasswordFormik.touched.email &&
                    !!forgotPasswordFormik.errors.email
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {forgotPasswordFormik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            )}

            {forgotPasswordStep === 2 && (
              <Form.Group className="mb-3" controlId="formBasicOtp">
                <Form.Label>Enter the OTP sent to {emailForReset}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter 6-digit OTP"
                  name="otp"
                  value={forgotPasswordFormik.values.otp}
                  onChange={forgotPasswordFormik.handleChange}
                  onBlur={forgotPasswordFormik.handleBlur}
                  isInvalid={
                    forgotPasswordFormik.touched.otp &&
                    !!forgotPasswordFormik.errors.otp
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {forgotPasswordFormik.errors.otp}
                </Form.Control.Feedback>
              </Form.Group>
            )}

            {forgotPasswordStep === 3 && (
              <>
                <Form.Group className="mb-3" controlId="formBasicNewPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    name="newPassword"
                    value={forgotPasswordFormik.values.newPassword}
                    onChange={forgotPasswordFormik.handleChange}
                    onBlur={forgotPasswordFormik.handleBlur}
                    isInvalid={
                      forgotPasswordFormik.touched.newPassword &&
                      !!forgotPasswordFormik.errors.newPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {forgotPasswordFormik.errors.newPassword}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="formBasicConfirmNewPassword"
                >
                  <Form.Label>Confirm New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm new password"
                    name="confirmNewPassword"
                    value={forgotPasswordFormik.values.confirmNewPassword}
                    onChange={forgotPasswordFormik.handleChange}
                    onBlur={forgotPasswordFormik.handleBlur}
                    isInvalid={
                      forgotPasswordFormik.touched.confirmNewPassword &&
                      !!forgotPasswordFormik.errors.confirmNewPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {forgotPasswordFormik.errors.confirmNewPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleCloseForgotPasswordModal}
            >
              Close
            </Button>
            <Button variant="primary" type="submit">
              {forgotPasswordStep === 1 && "Send OTP"}
              {forgotPasswordStep === 2 && "Verify OTP"}
              {forgotPasswordStep === 3 && "Reset Password"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default HRMSLogin;
